import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DownloadIcon } from 'common-assets/assets/icons/download.svg';
import { Button, InlineButton } from 'ui-components';
import {
  CALC_OUTCOME_TEST_ID,
  RETIREMENT_CALCULATOR_NAMESPACE,
} from '../../tools/RetirementCalculator.const';
import { RetirementCalculatorOutcomeActionsPropsModel } from './RetirementCalculatorOutcome.model';

import useStyles from './RetirementCalculatorOutcome.style';

export const RetirementCalculatorOutcomeActions: React.FC<
  RetirementCalculatorOutcomeActionsPropsModel
> = ({ productName, learnMoreLabel, learnMoreUrl, onDownloadSummary }) => {
  const c = useStyles({});
  const [t] = useTranslation(RETIREMENT_CALCULATOR_NAMESPACE, { useSuspense: false });

  return (
    <div className={c.actions}>
      {onDownloadSummary && (
        <InlineButton
          onClick={onDownloadSummary}
          customIcon={<DownloadIcon />}
          iconPlacement="left"
          testId={`${CALC_OUTCOME_TEST_ID}-download`}
        >
          {t('outcome.download')}
        </InlineButton>
      )}
      <Button
        href={learnMoreUrl}
        className={c.learnMoreButton}
        testId={`${CALC_OUTCOME_TEST_ID}-learn-more`}
      >
        {learnMoreLabel ?? t('outcome.learn-more', { product: productName })}
      </Button>
    </div>
  );
};
